import regexps from '../constants/regexps';

const clearNumberFiled = (value) => value.toString().replace(/(\D)/g, '');

export const requiredValidator = (value) => (
  typeof value === 'number'
  || (!!value && !!value.trim())
);
export const emailValidator = (value) => regexps.email.test(value);
export const postalCodeValidator = (value) => regexps.postalCode.test(value);
export const minValueValidator = (minValue) => (value) => (
  requiredValidator(value)
  && clearNumberFiled(value) >= minValue
);
export const maxValueValidator = (maxValue) => (value) => (
  requiredValidator(value)
  && clearNumberFiled(value) <= maxValue
);
export const maxLengthValidator = (maxLength) => (value) => (value && value.length) < maxLength;
export const minDateValidator = (minDate) => (value) => value > minDate;
